// The former install-first landing page is retired.
// Registration is now the first screen, including the original hero copy.
import React from "react";
import { Navigate } from "react-router-dom";

export default function Landing() {
  return <Navigate to="/register" replace />;
}
